<template>
  <form class="w-100 position-relative" @submit.stop.prevent="searchsubmit">
    <input
      ref="input"
      autocomplete="off"
      class="form-control publicsearch"
      :placeholder="full_placeholder"
      style="padding-left: 40px"
      type="search"
      :value="query"
      @input="searchinput"
    />
    <icon
      class="position-absolute top-50 translate-middle-y start-0 ms-3"
      name="SEARCH"
    />
  </form>
</template>

<script lang="ts">
import icon from "@pdfking/workflow/components/icon"
import can_hover from "../features/can_hover"
import close from "../mixins/close"
import get_route_props from "../routes/get_route_props"
import navigate from "../routes/navigate"
import { SEARCH_VIEW } from "../routes/urls"
import keyboard from "../state/keyboard"
import user from "../state/user"

export default {
  beforeUnmount() {
    document.removeEventListener("focus_search", this.focus_search)
  },
  components: { icon },
  computed: {
    full_placeholder() {
      return user.is_staff ? `${this.placeholder} (⌘K)` : this.placeholder
    },
    query() {
      if (this.$route.name == SEARCH_VIEW) {
        return get_route_props(this.$route).query
      }
      return null
    },
  },
  methods: {
    focus_search() {
      if (can_hover()) {
        // @ts-expect-error - $refs.input is a template ref
        this.$refs.input.focus()
      }
    },
    keypress(event: KeyboardEvent) {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k")
        // @ts-expect-error - $refs.input is a template ref
        this.$refs.input.focus()
    },
    searchinput(e: Event) {
      const query = (e.target as HTMLInputElement).value

      if (query) {
        navigate(SEARCH_VIEW, { query })
      } else {
        this.close()
      }
    },
    searchsubmit() {
      // @ts-expect-error - $refs.input is a template ref
      navigate(SEARCH_VIEW, { query: this.$refs.input.value, send: 1 })
    },
  },
  mixins: [close],
  mounted() {
    keyboard.register(this.keypress)
    document.addEventListener("focus_search", this.focus_search)
  },
  props: ["placeholder"] as const,
}
</script>
